<ion-split-pane contentId="main" when="xl" disabled>
    <!--  the side menu  -->

    <ng-container *ngIf="userFacade.userState$ | async as userState">
        <ion-menu menuId="main" side="end" contentId="main" *transloco="let t; read: 'appMenu'" [disabled]="!userState.jwt">
            <ion-header>
                <ion-toolbar color="light">
                    <ion-title>DAWBA</ion-title>
                </ion-toolbar>
            </ion-header>
            <ion-content>
                <ion-list lines="none">
                    <ion-item>
                        <ion-icon name="person-outline" slot="start"></ion-icon>
                        <ion-text class="ion-text-wrap">
                            <h2>{{ userState.fullName }}</h2>
                        </ion-text>
                    </ion-item>
                </ion-list>

                <ion-list lines="none">
                    <ion-list-header>
                        <ion-label>Menu</ion-label>
                    </ion-list-header>
                    <ion-item button (click)="goToDashboard()">
                        <ion-icon name="home-outline" color="primary" slot="start"></ion-icon>
                        {{ t('dashboardBtn') }}
                    </ion-item>
                    <ion-item button (click)="goToOnboarding()">
                        <ion-icon name="albums-outline" color="primary" slot="start"></ion-icon>
                        {{ t('onboardingBtn') }}
                    </ion-item>
                    <ion-item button (click)="triggerLogoutAlert()">
                        <ion-icon name="log-out-outline" color="primary" slot="start"></ion-icon>
                        {{ t('logoutBtn') }}
                    </ion-item>
                </ion-list>

                <ion-list lines="none">
                    <ion-radio-group [value]="selectedLang" (ionChange)="langChanged($event)">
                        <ion-list-header>
                            <ion-label>{{ t('availableLanguages') }}</ion-label>
                        </ion-list-header>

                        <ion-item>
                            <ion-label>{{ t('danishLang') }}</ion-label>
                            <ion-radio slot="start" value="da-DK"></ion-radio>
                        </ion-item>

<!--                         <ion-item>
                            <ion-label>{{ t('englishLang') }}</ion-label>
                            <ion-radio slot="start" value="en-GB"></ion-radio>
                        </ion-item> -->
                    </ion-radio-group>
                </ion-list>
            </ion-content>
        </ion-menu>
    </ng-container>

    <!-- the main content -->
    <ion-router-outlet id="main"></ion-router-outlet>
</ion-split-pane>